/* eslint-disable max-len */
import 'react';

const WarningSvg2 = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="wiki_WarningSvg2___c">
                <stop stopColor="#FF784F" offset="0%" />
                <stop stopColor="#FF4A4A" offset="100%" />
            </linearGradient>
            <linearGradient x1="0%" y1="48.858%" x2="100%" y2="50.945%" id="wiki_WarningSvg2___e">
                <stop stopColor="#FFF" offset="0%" />
                <stop stopColor="#FFD7D8" offset="100%" />
            </linearGradient>
            <linearGradient x1="49.244%" y1="-20.735%" x2="50.756%" y2="108.562%" id="wiki_WarningSvg2___f">
                <stop stopColor="#FFF" offset="0%" />
                <stop stopColor="#FFD7D8" offset="100%" />
            </linearGradient>
            <filter
                x="-31.2%"
                y="-25%"
                width="162.5%"
                height="162.5%"
                filterUnits="objectBoundingBox"
                id="wiki_WarningSvg2___a"
            >
                <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur stdDeviation="1.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                <feColorMatrix
                    values="0 0 0 0 1 0 0 0 0 0.368627451 0 0 0 0 0.329411765 0 0 0 0.3 0"
                    in="shadowBlurOuter1"
                />
            </filter>
            <filter
                x="-68.2%"
                y="-85%"
                width="236.4%"
                height="270%"
                filterUnits="objectBoundingBox"
                id="wiki_WarningSvg2___d"
            >
                <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                <feColorMatrix
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
                    in="shadowBlurOuter1"
                    result="shadowMatrixOuter1"
                />
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1" />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
            <circle id="wiki_WarningSvg2___b" cx="8" cy="8" r="8" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g opacity=".8" transform="translate(4 4)">
                <use fill="#000" filter="url(#wiki_WarningSvg2___a)" xlinkHref="#wiki_WarningSvg2___b" />
                <use fill="url(#wiki_WarningSvg2___c)" xlinkHref="#wiki_WarningSvg2___b" />
            </g>
            <g
                filter="url(#wiki_WarningSvg2___d)"
                transform="translate(6.497 7.56)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.6"
            >
                <path stroke="url(#wiki_WarningSvg2___e)" d="M6.296 3.19L0 3.21" transform="rotate(45 2.763 6.67)" />
                <path stroke="url(#wiki_WarningSvg2___f)" d="M3.158 6.4L3.138 0" transform="rotate(45 2.763 6.67)" />
            </g>
        </g>
    </svg>
);
export default WarningSvg2;
